export type CustomMapping = {
    customMappingSource: string;
    customMappingTarget: string | null;
    customMappingSourceId: number | null;
};

export const mkCustomMapping = (): CustomMapping => ({
    customMappingSource: '',
    customMappingTarget: null,
    customMappingSourceId: null,
});

export const validateCustomMapping = (customMapping: CustomMapping) => ({
    customMappingSource:
        (customMapping.customMappingTarget || customMapping.customMappingSourceId) && !customMapping.customMappingSource
            ? 'Required'
            : undefined,
    customMappingSourceId: undefined,
    customMappingTarget:
        customMapping.customMappingSource && !customMapping.customMappingTarget ? 'Required' : undefined,
});

export const isNonEmptyAndValid = (customMapping: CustomMapping): boolean =>
    Object.values(validateCustomMapping(customMapping)).every(x => x === undefined) &&
    customMapping.customMappingTarget !== null;

export const sanitizeSourceString = (customMapping: CustomMapping): CustomMapping => ({
    ...customMapping,
    customMappingSource: customMapping.customMappingSource.trim(),
});
